import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ImageCroppedEvent } from "ngx-image-cropper";
import Swal, { SweetAlertType } from "sweetalert2";

@Component({
  selector: "app-cropped-dialog",
  templateUrl: "./cropped-personal-store.component.html",
  styleUrls: ["./cropped-personal-store.scss"]
})
export class CroppedPersonalStoreComponent implements OnInit {
  ratio: number;
  imageChangedEvent;
  croppedImageFile: File;
  croppedImageBase = "";

  constructor(public dialogRef: MatDialogRef<CroppedPersonalStoreComponent>) {}

  ngOnInit() {
    if (!this.ratio) {
      this.ratio = 10 / 4;
    }
  }

  alert(title: string, icon: SweetAlertType) {
    Swal.fire({
      type: icon,
      title,
      showConfirmButton: false,
      timer: 1500
    });
  }

  base64ToFile(data: string, filename: string) {
    const arr = data.split(",");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: "image/jpeg" });
  }

  fileChangeEvent(file: File) {
    const fileSize = file[0].size;
    const fileType = file[0].type;
    const maxSizeInBytes = 15000000;

    this.imageChangedEvent = event;

    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      this.alert("Formato de arquivo não permitido", "error");
      this.dialogRef.close();
    } else if (fileSize > maxSizeInBytes) {
      this.alert("Arquivo excede o tamanho de 15mb", "error");
      this.dialogRef.close();
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImageBase = event.base64;
    this.croppedImageFile = this.base64ToFile(event.base64, this.imageChangedEvent.target.files[0].name);
  }

  close() {
    this.dialogRef.close({
      croppedImageFile: this.croppedImageFile,
      croppedImageBase: this.croppedImageBase,
      file: this.imageChangedEvent
    });
  }
}
